import { BrowserRouter, Switch, Route, HashRouter } from 'react-router-dom';

import React, { Component } from 'react';
import NotFound from 'Home/CommonResources/NotFound/NotFound';

import Home from 'Home/Components/Home/Home';


export class RoutesSetup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isAdmin: false,
            adminDetailsFetching: false
        };
    }

    render() {
        return (
            <>
                <HashRouter>
                    <Switch>
                        <Route exact path="/" component={Home} />
                        <Route path="*" component={NotFound} />
                    </Switch>
                </HashRouter>
            </>
        )
    }
}

export default RoutesSetup;
